angular.module('am4').directive('defaultNgMessages', function() {
    return {
        restrict: 'EA',
        template: require('./defaultNgMessages.html')
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/defaultNgMessages.js